import type { DiscountVO } from "./types/order"
import { DISCOUNT_TYPE } from "@/constants/discountType"

function roundRate(value: number): number {
  return Number(value.toFixed(12))
}

export function manualOrderDiscountPercentToBackend(percent: number): number {
  return roundRate(Number(percent) / 100)
}

export function normalizeManualOrderDiscountRateForBackend(rate: number): number {
  const numericRate = Number(rate)
  return numericRate > 1 ? manualOrderDiscountPercentToBackend(numericRate) : numericRate
}

export function manualOrderDiscountRateToFrontendPercent(rate: number): number {
  return roundRate(normalizeManualOrderDiscountRateForBackend(rate) * 100)
}

export function normalizeOrderDiscountRatesForBackend<T extends DiscountVO>(
  discounts: T[],
): T[] {
  return discounts.map((discount) => {
    if (
      discount.discountType !== DISCOUNT_TYPE.DISCOUNT_TYPE_MANUAL
      || discount.discountRate == null
    ) {
      return discount
    }
    return {
      ...discount,
      discountRate: normalizeManualOrderDiscountRateForBackend(discount.discountRate),
    }
  })
}
